/**
 * Pre-redirect confirmation modal.
 *
 * The actual card form lives on Kapital Bank's hosted payment page. This modal just shows
 * the customer what they're about to pay and asks them to confirm before we redirect.
 *
 * Props:
 *  - isOpen, title, amount, currency       — display
 *  - description?                          — optional copy under the amount
 *  - onConfirm()                           — called when user clicks Continue; no token arg
 *  - onCancel(), loading                   — standard modal controls
 */

import { useTranslation } from "react-i18next";

const overlay = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
};
const modal = {
  background: "#fff", padding: "24px", borderRadius: "6px",
  width: "100%", maxWidth: "440px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
};
const btnRow = { display: "flex", gap: "8px", justifyContent: "flex-end", marginTop: "20px" };
const primaryBtn = {
  padding: "10px 16px", background: "#2563eb", color: "#fff",
  border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: 600
};
const ghostBtn = {
  padding: "10px 16px", background: "#fff", color: "#374151",
  border: "1px solid #d1d5db", borderRadius: "4px", cursor: "pointer"
};
const infoBox = {
  background: "#f3f4f6", padding: "12px 14px", borderRadius: "4px",
  fontSize: 13, color: "#374151", lineHeight: 1.5, marginTop: 16
};

const PaymentModal = ({
  isOpen,
  title,
  amount,
  currency = "₼",
  description,
  onConfirm,
  onCancel,
  loading,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div style={overlay} role="dialog" aria-modal="true">
      <div style={modal}>
        <h3 style={{ marginTop: 0 }}>{title || t("pages.payment.title")}</h3>

        <div style={{ marginBottom: 4 }}>
          <div style={{ color: "#6b7280", fontSize: 14 }}>{t("pages.payment.amount")}</div>
          <div style={{ fontSize: 26, fontWeight: 700 }}>
            {amount} {currency}
          </div>
        </div>

        {description && (
          <div style={{ color: "#4b5563", fontSize: 14, marginTop: 6 }}>{description}</div>
        )}

        <div style={infoBox}>
          {t("pages.payment.info")}
        </div>

        <div style={btnRow}>
          <button style={ghostBtn} onClick={onCancel} disabled={loading}>
            {t("pages.payment.cancel")}
          </button>
          <button style={primaryBtn} onClick={onConfirm} disabled={loading}>
            {loading ? t("pages.payment.redirecting") : t("pages.payment.continue")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
